import { MTableEditField } from '@material-table/core';
import React from 'react';
import { POLIMER, SUBSTANCE } from 'utils/constants/coreConstants';
import { shortDate as dateFormater } from 'utils/helperFunctions/dateFormat';

const emptyCellFiller = field => field ? field : '-';


export default [
  {
    title: 'Percentagem (%)',
    field: 'percentage',
    editable: 'never',
    sorting: false,
    minWidth: 125,
    headerStyle: {
      textAlign: 'center',
    },
    cellStyle: {
      textAlign: 'left',
    },
    render: rowData => rowData.percentage ?
      parseFloat(rowData.percentage) : rowData.percentage
  },
  {
    title: 'Tipo',
    field: 'type',
    sorting: false,
    minWidth: 125,
    editable: 'never',
    lookup: {
      [SUBSTANCE]: 'Substância',
      [POLIMER]: 'Polímero'
    }
  },
  {
    title: 'Nome',
    field: 'name',
    editable: 'never',
    minWidth: 250,
    headerStyle: {
      textAlign: 'center',
    },
    cellStyle: {
      textAlign: 'left',
    },
  },
  {
    title: 'EC',
    field: 'ec',
    sorting: false,
    editable: 'never',
    minWidth: 150,
    headerStyle: {
      textAlign: 'left',
    },
    cellStyle: {
      textAlign: 'left',
    },
  },
  {
    title: 'CAS',
    field: 'cas',
    sorting: false,
    editable: 'never',
    minWidth: 150,
    headerStyle: {
      textAlign: 'left',
    },
    cellStyle: {
      textAlign: 'left',
    },
  },
  {
    title: 'Nº Registo',
    field: 'registration_number',
    minWidth: 200,
    initialEditValue: '',
    sorting: false,
    headerStyle: {
      textAlign: 'center',
    },
    cellStyle: {
      textAlign: 'center',
    },
    editComponent: (props) => <MTableEditField fullminWidth {...props} multiline/>
  },
  {
    title: 'CE',
    field: 'exposure_scenario',
    sorting: false,
    initialEditValue: 'sim',
    minWidth: 50,
    headerStyle: {
      textAlign: 'center',
    },
    cellStyle: {
      textAlign: 'center',
    },
    lookup: {
      //'-': '-',
      'sim': 'Sim',
      'nao': 'Não',
      'na': 'N/A'
    }
  },
  {
    title: 'Data Recepção CE',
    field: 'received_on',
    type: 'date',
    sorting: false,
    minWidth: 100,
    headerStyle: {
      textAlign: 'center',
    },
    cellStyle: {
      textAlign: 'center',
    },
    initialEditValue: null,
    render: ({ received_on }) => received_on && emptyCellFiller(dateFormater(received_on))
  },
  {
    title: 'Observações',
    field: 'observations',
    sorting: false,
    minWidth: 250,
    headerStyle: {
      textAlign: 'center',
    },
    cellStyle: {
      textAlign: 'left',
    },
    editComponent: (props) => <MTableEditField fullWidth {...props} multiline/>
  }
];
